import { setCollections } from '@common/redux/slice/database';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { fetchCollections } from '@common/services/featherIO';

export const useCollections = ({ appId }: { appId: string }) => {
  const dispatch = useDispatch();

  const _fetchCollections = useCallback(async () => {
    const collections = await fetchCollections(appId);
    dispatch(setCollections(collections));
  }, [appId]);

  useEffect(() => {
    _fetchCollections();
  }, [_fetchCollections]);
};
